import CustomerPaymentsHtml from './customer-payments.html';

export function CustomerPaymentsDirective () {
  return {
    controller : 'CustomerPaymentsCtrl',
    restrict   : 'E',
    templateUrl: CustomerPaymentsHtml,
    scope      : {
      customer: '=',
      payments: '='
    }
  };
}
